  export const timeSchedule = [
    "00am - 01am",
    "01am - 02am",
    "02am - 03am",
    "03am - 04am",
    "04am - 05am",
    "05am - 06am",
    "06am - 07am",
    "07am - 08am",
    "08am - 09am",
    "09am - 10am",
    "10am - 11am",
    "11am - 12pm",
    "12pm - 01pm",
    "01pm - 02pm",
    "02pm - 03pm",
    "03pm - 04pm",
    "04pm - 05pm",
    "05pm - 06pm",
    "06pm - 07pm",
    "07pm - 08pm",
    "08pm - 09pm",
    "09pm - 10pm",
    "10pm - 11pm",
    "11pm - 12am"
  ];

  export const weekDays = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday"
  ];